export default __webpack_public_path__ + "static/media/user.18f20108.svg";